const Handlebars = require("@cirrus/legacy/vendor-bower/handlebars/handlebars")
const Utils = require("@cirrus/legacy/app-common/utils/utils.es6").default

const getDuration = Utils.getDuration
const getMoment = Utils.getMoment
const getMomentByDateTimeZone = Utils.getMomentByDateTimeZone

const formatTime = Utils.formatTime

function setMomentLocal() {
  var lang = App.regionalSettings.lang

  var dateFormats = moment.localeData(App.regionalSettings.formats)._longDateFormat

  dateFormats.LT = App.regionalSettings.stformat
  dateFormats.LTS = App.regionalSettings.ltformat
  if (lang == "en-US") dateFormats.L = "MM/DD/YYYY"
  var ldata = moment.localeData(lang)

  if (!ldata) {
    ldata = moment.localeData("en-GB")
  }

  moment.locale("custom-locale", {
    months: ldata._months,
    monthsShort: ldata._monthsShort,
    weekdays: ldata._weekdays,
    weekdaysShort: ldata._weekdaysShort,
    weekdaysMin: ldata._weekdaysMin,
    longDateFormat: dateFormats,
    calendar: ldata._calendar,
    relativeTime: ldata._relativeTime,
    ordinalParse: ldata._ordinalParse,
    ordinal: ldata._ordinal,
    week: ldata._week,
  })
}

function getMomentDuration(m) {
  return moment.duration({
    minutes: m,
  })
}

Handlebars.registerHelper("dtDashboardFromNow", function (dt) {
  return App.Text.get("TestBeginsTime", "General").replace("{0}", getMoment(dt).fromNow()) // 'Test begins {0}'
})
Handlebars.registerHelper("dtMonthYear", function (dt) {
  return getMoment(dt).format("LL")
})
Handlebars.registerHelper("dtDayMonthYearTime", function (dt, extra) {
  if (dt) {
    return getMoment(dt).format("L")
  } else return "Not set"
})
Handlebars.registerHelper("dtDayMonthYearShortTimeWithSec", function (dt) {
  if (dt) {
    //There is incorrect format in LTS
    var localedata = moment.localeData()

    var timeFormat = localedata && localedata._longDateFormat.LT.replace(":mm", ":mm:ss")

    return getMomentByDateTimeZone(dt).format("L " + timeFormat)
  } else return "-"
})
Handlebars.registerHelper("dtDayMonthYearShortTimeDelivery", function (dt, extra) {
  if (dt) {
    return moment(dt).format("L LT")
  } else return "-"
})
Handlebars.registerHelper("dtFullTime", function (dt, extra) {
  if (dt) {
    var date = getMoment(dt)

    if (extra) {
      date = date.add("minutes", extra)
    }

    return date.format("LLL")
  } else return "Not set"
})
Handlebars.registerHelper("dtInvigilation", function (dt) {
  if (dt) {
    var dateWithTimeZone = getMomentByDateTimeZone(dt)
    return dateWithTimeZone.format("LLL")
  } else return "---"
})
Handlebars.registerHelper("getTimeDuration", function (dtStart, dtEnd) {
  return dtStart && dtEnd
    ? getDuration(dtStart, dtEnd).humanize()
    : App.Text.get("Unlimited", "General") // 'Unlimited'
})
Handlebars.registerHelper("getDuration", function (minutes) {
  if (!minutes) return App.Text.get("Unlimited", "General") //var minutes = getMomentDuration(minutes).asMinutes();

  var result = minutes + " " + App.Text.get("Minutes", "General")
  return result
})
Handlebars.registerHelper("dtDuration", function (duration) {
  return duration ? Math.floor(duration / 60) : 0
})
Handlebars.registerHelper("formatTimer", function (min) {
  return formatTime(min)
})
Handlebars.registerHelper("dtOnlyTime", function (dt) {
  if (dt) return getMoment(dt).format("LT")
  return App.Text.get("NotSet", "General")
})
Handlebars.registerHelper("dtOnlyDate", function (dt) {
  if (dt) return getMoment(dt).format("L")
  return App.Text.get("NotSet", "General")
})
Handlebars.registerHelper("dtDate", function (dt) {
  return moment(dt).fromNow().format("L LT")
})
Handlebars.registerHelper("dtDate2", function (dt) {
  if (dt) return getMoment(dt).format("LL")
  return App.Text.get("NotSet", "General")
})
Handlebars.registerHelper("dtLastOnline", function (dt) {
  if (dt) {
    var date = getMoment(dt)
    if (date.get("year") < 1800) return App.Text.get("Never", "General").toLowerCase() // 'never'

    return date.format("LLL")
  }

  return App.Text.get("Never", "General").toLowerCase()
})

function register(helpers) {
  for (key in helpers) {
    var value = helpers[key]
    Handlebars.registerHelper(key, value)
  }
}

register({
  dtDayMonthYear: Utils.dtDayMonthYear,
  dtMonthNameDayYear: Utils.dtMonthNameDayYear,
  shortTime: Utils.ShortTime,
  dtDayMonthYearShortTime: Utils.dtDayMonthYearShortTime,
})
module.exports.setMomentLocal = setMomentLocal
